import { useEffect, useState } from 'react';
import { getEmojiLabel, loadEmojiGroups } from './registry';

let priming: Promise<unknown> | null = null;

function prime(): Promise<unknown> {
  if (!priming) priming = loadEmojiGroups('fi');
  return priming;
}

// React hook around getEmojiLabel that triggers a re-render once the emoji
// dataset has loaded, so editor preview aria-labels reflect the localized
// name even when the picker has not been opened yet.
export function useEmojiLabel(emoji: string): string {
  const [, bumpVersion] = useState(0);
  useEffect(() => {
    let alive = true;
    void prime().then(() => {
      if (alive) bumpVersion((n) => n + 1);
    });
    return () => {
      alive = false;
    };
  }, []);
  return getEmojiLabel(emoji);
}
